import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { PlusIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';
import { cn } from '../../../../libs/utils/TailwindMerge';
import { useAppSelector } from '../../../../redux/app/hooks';
import { RootState } from '../../../../redux/app/store';
import { FeatureKeys } from '../../../../redux/features/app/AppState';
import { JoinChatDialog } from '../Dialogs/JoinChatDialog';

interface NewChatMenuProps {
    appbar?: boolean;
    newChat: () => void;
}

export const NewChatMenu: React.FC<NewChatMenuProps> = ({ appbar, newChat }) => {
    const { features } = useAppSelector((state: RootState) => state.app);

    const [joinDialogOpen, setJoinDialogOpen] = useState(false);

    if (features[FeatureKeys.MultiUserChat].enabled) {
        return (
            <>
                <JoinChatDialog open={joinDialogOpen} setOpen={setJoinDialogOpen} />
                <Menu
                    as="div"
                    className={cn(
                        appbar ? '' : 'border w-full border-slate-300 dark:border-slate-600',
                        'relative inline-block text-left md:ml-0 rounded-lg ',
                    )}>
                    {appbar ? (
                        <MenuButton
                            title="New Chat"
                            className={`rounded-lg p-1 sm:p-1.5 text-slate-500 hover:bg-base-50 group px-2 hover:text-primary-300 text-base-500 hover:bg-slate-200 dark:text-slate-400 dark:hover:bg-slate-800`}>
                            <PlusIcon className="h-6 w-6" strokeWidth={2} />
                        </MenuButton>
                    ) : (
                        <MenuButton className="inline-flex w-full align-middle md:w-full gap-x-2 cursor-pointer justify-center shadow rounded-lg p-2 text-white bg-primary-300 hover:bg-primary-700 dark:text-slate-50 transition-all duration-200">
                            <PlusIcon className="h-5 w-5" strokeWidth={2} />
                            New Chat
                        </MenuButton>
                    )}
                    <MenuItems
                        transition
                        className={cn(
                            appbar ? 'bottom-full sm:bottom-auto sm:left-0' : 'right-0',
                            'absolute z-10 mb-2 sm:mb-0 sm:mt-2 w-56 origin-bottom-right sm:origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in overflow-hidden dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm',
                        )}>
                        <MenuItem>
                            <button
                                onClick={newChat}
                                className="items-center flex flex-row w-full text-left px-3 py-2 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none dark:data-[focus]:text-slate-200 dark:data-[focus]:bg-slate-500 cursor-pointer">
                                <span>New Chat Session</span>
                            </button>
                        </MenuItem>
                        <MenuItem>
                            <button
                                onClick={() => setJoinDialogOpen(true)}
                                className="items-center flex flex-row w-full text-left px-3 py-2 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none dark:data-[focus]:text-slate-200 dark:data-[focus]:bg-slate-500 cursor-pointer">
                                <span>Join Shared Chat</span>
                            </button>
                        </MenuItem>
                    </MenuItems>
                </Menu>
            </>
        );
    } else {
        if (appbar) {
            return (
                <a
                    href="#"
                    title="New Chat"
                    onClick={newChat}
                    className={`rounded-lg p-1 sm:p-1.5 text-slate-500 hover:bg-base-50 group px-2 hover:text-primary-300 text-base-500 hover:bg-slate-200 dark:text-slate-400 dark:hover:bg-slate-800`}>
                    <PlusIcon className="h-6 w-6" strokeWidth={2} />
                </a>
            );
        } else {
            return (
                <button
                    onClick={newChat}
                    className="inline-flex w-full align-middle md:w-full gap-x-2 cursor-pointer justify-center shadow rounded-lg p-2 text-white bg-primary-300 hover:bg-primary-700 dark:text-slate-50 transition-all duration-200">
                    <PlusIcon className="h-5 w-5" strokeWidth={2} />
                    New Chat
                </button>
            );
        }
    }
};
